let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2WNCJ")).then(() => parcelRequire('7cId8'));